import { Component, OnInit, Input, Optional, Self, ElementRef } from '@angular/core';
import { MatLegacyFormFieldControl as MatFormFieldControl } from '@angular/material/legacy-form-field';
import { ControlValueAccessor, UntypedFormGroup, NgControl, UntypedFormBuilder } from '@angular/forms';
import { Subject } from 'rxjs';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { FocusMonitor } from '@angular/cdk/a11y';
import { LottolocaNumber } from '../../models/grid-number.model';

@Component({
  selector: 'lottoloca-number-list',
  templateUrl: './lottoloca-number-list.component.html',
  styleUrls: ['./lottoloca-number-list.component.scss'],
  providers: [

    { provide: MatFormFieldControl, useExisting: LottolocaNumberListComponent },

  ],
  host: {
    '[class.floating]': 'shouldLabelFloat',
    '[id]': 'id',
    '[attr.aria-describedby]': 'describedBy',
  }
})
export class LottolocaNumberListComponent implements MatFormFieldControl<LottolocaNumber[]>, ControlValueAccessor {


  @Input() isTextArea: boolean = true;

  static nextId = 0;
  parts: UntypedFormGroup;
  stateChanges = new Subject<void>();
  focused = false;
  //ngControl = null;
  errorState = false;
  controlType = 'lottoloca-number-list';
  id = `lottoloca-number-list-${LottolocaNumberListComponent.nextId++}`;
  describedBy = '';


  private onChange: (value: LottolocaNumber[]) => void;

  public changeData() {

    this.onChange(this.value);
  }

  writeValue(obj: LottolocaNumber[]): void {
    this.value = obj;
  }
  registerOnChange(onChange: (value: LottolocaNumber[]) => void): void {
    this.onChange = onChange;
  }
  registerOnTouched(fn: any): void {
    //throw new Error("Method not implemented.");
  }
  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;

    if (isDisabled) {
      this.parts.get("textValue").disable();
    }
    else {
      this.parts.get("textValue").enable();
    }
  }


  get empty() {
    const { value: { textValue } } = this.parts;

    // console.log("empty:" + dateText + !dateText);
    return !textValue;
  }

  get shouldLabelFloat() { return this.focused || !this.empty; }

  @Input()
  get placeholder(): string { return this._placeholder; }
  set placeholder(value: string) {
    this._placeholder = value;
    this.stateChanges.next();
  }
  private _placeholder: string;

  @Input()
  get required(): boolean { return this._required; }
  set required(value: boolean) {
    this._required = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _required = false;

  @Input()
  get disabled(): boolean { return this._disabled; }
  set disabled(value: boolean) {
    this._disabled = coerceBooleanProperty(value);
    this.stateChanges.next();
  }
  private _disabled = false;

  @Input()
  get value(): LottolocaNumber[] | null {

    const { value: { textValue } } = this.parts

    let numbers: Array<LottolocaNumber> = new Array();

 
      let texts = textValue.split(";");



      texts.forEach(x => {

        x = x.trim();

        if (x != null && x != '') {

          let pos1 = x.indexOf("(");

  
          let value = parseInt(x.substring(0,pos1));

           
          let details = x.substring(pos1+1,x.length-1).split('|');

   
          let number = new LottolocaNumber();
          number.value = value;
          number.name = details[0];
          number.description = details[1];

          numbers.push(number);

        }

      });
  




    return numbers;

  }

  set value(value: LottolocaNumber[] | null) {



    let text: string = '';
    if (value != null) {
      
      value.forEach(x => {
        if (x != null && x.value != null) {
          text += x.value.toString() + ' ';

          if(x.name ==  null || x.name == "")
          {
            text +=   " (" + x.value.toString() + "|"+x.value.toString()+"); "
          }
          else
          {
            if(x.description == null)
            {
            text +=   " (" + x.name.toString() + "|"+x.value.toString()+"); "
            }
            else{
              text +=   " (" + x.name.toString() + "|"+x.description.toString()+"); "
            }
          
          }
        }
      });

      if(text == null || text == "")
      {

        value.forEach(x => {
          if (x != null) {
            text += x.toString() + ' ';
  
              text +=   " (" + x.toString() + "|"+x.toString()+ "); "
           
          }
        });
      }


      this.parts.get("textValue").setValue(text.trim());

    }
    this.stateChanges.next();
  }

  constructor(@Optional() @Self() public ngControl: NgControl, fb: UntypedFormBuilder, private fm: FocusMonitor, private elRef: ElementRef<HTMLElement>) {

    // Setting the value accessor directly (instead of using
    // the providers) to avoid running into a circular import.
    if (this.ngControl != null) { this.ngControl.valueAccessor = this; }

    this.parts = fb.group({
      textValue: ''
    });

    fm.monitor(elRef.nativeElement, true).subscribe(origin => {
      this.focused = !!origin;
      this.stateChanges.next();
    });
  }

  ngOnDestroy() {
    this.stateChanges.complete();
    this.fm.stopMonitoring(this.elRef.nativeElement);
  }

  setDescribedByIds(ids: string[]) {
    this.describedBy = ids.join(' ');
  }

  onContainerClick(event: MouseEvent) {

    if (this.isTextArea) {
      if ((event.target as Element).tagName.toLowerCase() != 'textarea') {
        this.elRef.nativeElement.querySelector('textarea')!.focus();
      }
      else {
        if ((event.target as Element).tagName.toLowerCase() != 'input') {
          this.elRef.nativeElement.querySelector('input')!.focus();
        }
      }
    }
  }
}
